export const MAY = 4

export const today = new Date(Date.now()) // equivalent to just new Date(), but much easier to stub for tests

export const relevantYear = today.getMonth() > MAY ? today.getUTCFullYear() : today.getUTCFullYear() - 1
